import { Pipe, PipeTransform } from '@angular/core';
import { IDifference } from "libraries/interfaces/fare-optimisation/IFareOptimisation";


@Pipe({
  name: 'computeOfferAndBookingValue'
})
export class ComputeOfferAndBookingValuePipe implements PipeTransform {

  transform(value: IDifference, usePipe?: string): string {
    if(value.actualValue && value.otherValue && value.actualValue !== value.otherValue){
        return `${value.otherValue} > ${value.actualValue}`;
    }
      return `${value.actualValue}`;
  }

}
